<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/" text="Vissza"></ion-back-button>
    </ion-buttons>
    <ion-title>Akadálymentesítési nyilatkozat</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="akadalymentesseg">
  <main class="lap" id="nyilatkozat">
    <h1>Akadálymentesítési nyilatkozat</h1>

    <p>
      A SULINFORM rendszert használó intézmény (a továbbiakban: intézmény) elkötelezett amellett, hogy
      webes felületét és mobilalkalmazását a közszférabeli szervezetek honlapjainak és
      mobilalkalmazásainak akadálymentesítéséről szóló <b>2018. évi LXXV. törvénnyel</b> összhangban
      akadálymentessé tegye. A rendszert a Cronomit fejleszti és üzemelteti.
    </p>

    <section aria-labelledby="ak-hataly">
      <h2 id="ak-hataly">A nyilatkozat hatálya</h2>
      <p>Ez az akadálymentesítési nyilatkozat a következőkre vonatkozik:</p>
      <ul>
        <li>
          a SULINFORM webes felülete (az intézmény SULINFORM-címén böngészőből elérhető alkalmazás<span
            *ngIf="cim">, jelenleg: <b>{{ cim }}</b></span>);
        </li>
        <li>a SULINFORM mobilalkalmazás (Android és iOS).</li>
      </ul>
    </section>

    <section aria-labelledby="ak-statusz">
      <h2 id="ak-statusz">Megfelelőségi státusz</h2>
      <p>
        A webes felület és a mobilalkalmazás <b>részben megfelel</b> a 2018. évi LXXV. törvény 3. §-ában
        meghatározott követelményeknek, illetve az EN 301 549 szabványnak (amely a webes tartalmakra a
        WCAG 2.1 „AA” szintjének követelményeit veszi át) az alább felsorolt nem megfelelőségek miatt.
      </p>
    </section>

    <section aria-labelledby="ak-nem">
      <h2 id="ak-nem">Nem akadálymentes tartalom</h2>
      <p>Az alább felsorolt tartalmak az alábbi okok miatt nem akadálymentesek.</p>

      <h3>a) A vonatkozó jogszabálynak való meg nem felelés</h3>
      <ul>
        <li>
          Egyes képernyőkön a csak ikonnal jelölt gombok és vezérlők nem rendelkeznek szöveges
          (ARIA) címkével, ezért képernyőolvasóval nem minden esetben azonosíthatók
          (WCAG 2.1: 1.1.1, 4.1.2).
        </li>
        <li>
          Egyes képernyők – különösen a táblázatos és az adminisztrációs nézetek – egyes szöveg- és
          háttérszín-párosításai nem érik el az előírt kontrasztarányt (WCAG 2.1: 1.4.3, 1.4.11).
        </li>
        <li>
          A rendszer által előállított PDF-dokumentumok egy része (például egyes nyomtatványok,
          kimutatások és bizonyítvány-kivonatok) nem tartalmaz akadálymentes szerkezeti jelölést
          (címkézett PDF), ezért képernyőolvasóval nehezen értelmezhető (WCAG 2.1: 1.3.1).
        </li>
      </ul>
      <p>
        A hiányosságok javítása folyamatos; a felhasználói visszajelzések alapján a leggyakrabban
        használt képernyők javítása élvez elsőbbséget.
      </p>

      <h3>b) Aránytalan teher</h3>
      <p>Az intézmény aránytalan teherre nem hivatkozik.</p>

      <h3>c) A vonatkozó jogszabály hatálya alá nem tartozó tartalom</h3>
      <ul>
        <li>
          Harmadik fél tulajdonában lévő, nem az intézmény által finanszírozott vagy fejlesztett és nem
          az irányítása alá tartozó tartalmak (például külső fizetési oldalak, beágyazott külső
          szolgáltatások) – a törvény 1. § (3) bekezdés g) pontja alapján.
        </li>
      </ul>
    </section>

    <section aria-labelledby="ak-keszites">
      <h2 id="ak-keszites">A nyilatkozat elkészítése</h2>
      <p>
        A nyilatkozat elkészítésének időpontja: <b>{{ keszult }}</b>.
        A nyilatkozat legutóbbi felülvizsgálata: <b>{{ felulvizsgalat }}</b>.
      </p>
      <p>A nyilatkozat a fejlesztő által végzett önértékelés alapján készült.</p>
    </section>

    <section aria-labelledby="ak-visszajelzes">
      <h2 id="ak-visszajelzes">Visszajelzés és elérhetőségek</h2>
      <p>
        Ha a webes felületen vagy a mobilalkalmazásban akadálymentességi hiányosságot tapasztal, vagy
        valamely nem akadálymentes tartalmat más, akadálymentes formában szeretne megkapni, jelezze:
      </p>
      <ul>
        <li>
          elsősorban az <b>intézmény kapcsolattartójánál</b> (az intézmény titkárságán vagy a
          honlapján megadott elérhetőségen);
        </li>
        <li>
          vagy a SULINFORM fejlesztőjénél, a Cronomit ügyfélszolgálatán:
          <a href="mailto:info@sulinform.hu">info&#64;sulinform.hu</a>.
        </li>
      </ul>
      <p>
        A bejelentésre vagy kérelemre az intézmény a törvény 4. § (2) bekezdése szerint
        <b>30 napon belül</b> válaszol.
      </p>
    </section>

    <section aria-labelledby="ak-vegrehajtas">
      <h2 id="ak-vegrehajtas">Végrehajtási eljárás</h2>
      <p>
        Ha a bejelentésére vagy kérelmére 30 napon belül nem kapott választ, vagy a válasz nem
        kielégítő, bejelentéssel fordulhat a 2018. évi LXXV. törvény 5. §-a és a
        162/2019. (VII. 5.) Korm. rendelet szerinti ellenőrző szervezethez, a
        <b>Digitális Magyarország Ügynökség Zrt. Digitális Szolgáltatások Felügyeletéhez (DSZF)</b>:
      </p>
      <ul>
        <li>
          elektronikus űrlapon a magyarorszag.hu portálon:
          <a href="https://www.magyarorszag.hu/szuf_ugyleiras?id=b2b447fa-5926-4911-85b7-a4d56583a501"
             target="_blank" rel="noopener">Felügyeleti bejelentés honlap vagy mobilalkalmazás
            akadálymentes elérhetőségével kapcsolatban</a>
          <span class="sr-only">(új ablakban nyílik)</span>;
        </li>
        <li>e-mailben: <a href="mailto:webakadalymentesites@dmu.gov.hu">webakadalymentesites&#64;dmu.gov.hu</a>;</li>
        <li>postai úton: Digitális Magyarország Ügynökség Zrt., 1138 Budapest, Váci út 129–133.</li>
      </ul>
      <p>A bejelentés alapján a DSZF egyszerűsített ellenőrzést folytat le, és annak eredményéről 60 napon belül tájékoztatja a bejelentőt.</p>
    </section>
  </main>
</ion-content>
